import { Navigate } from 'react-router-dom';

import { SuperAdminLayout } from '@/components/superadmin/superadmin-layout';
import { decodeJwtPayload, getJwtToken, isJwtValid } from '@/utils/self-hosted/jwt-manager';

/**
 * Gate for the operator console.
 *
 * Client-side only, and that is on purpose: this decides what to RENDER, never
 * what is permitted. Every `/v1/superadmin/*` call is independently checked by
 * `SuperAdminGuard` on the API, so forging a token claim in localStorage buys
 * an empty page and a wall of 401s.
 */
export function SuperAdminRoute() {
  const token = getJwtToken();

  if (!isJwtValid(token)) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  const claims = decodeJwtPayload<{ scope?: string }>(token);

  if (claims?.scope !== 'superadmin') {
    // A signed-in tenant who typed the URL belongs in their own dashboard.
    return <Navigate to="/" replace />;
  }

  return <SuperAdminLayout />;
}
